var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A36",
    fillRule: "evenodd",
    d: "M10.833 1.667a.833.833 0 0 0-1.666 0v3.334a.833.833 0 1 0 1.666 0V1.667Zm0 13.334a.833.833 0 0 0-1.666 0v3.333a.833.833 0 0 0 1.666 0v-3.333ZM3.52 3.52a.833.833 0 0 1 1.179 0l2.358 2.358a.833.833 0 0 1-1.178 1.179l-2.36-2.359a.833.833 0 0 1 0-1.178Zm10.604 9.425a.833.833 0 0 0-1.179 1.178l2.359 2.359a.834.834 0 0 0 1.178-1.179l-2.358-2.358ZM.833 10c0-.46.373-.834.834-.834H5a.833.833 0 0 1 0 1.667H1.667A.833.833 0 0 1 .833 10ZM15 9.167a.833.833 0 0 0 0 1.667h3.333a.833.833 0 0 0 0-1.667H15Zm-7.944 3.778a.833.833 0 0 1 0 1.178l-2.358 2.359a.833.833 0 0 1-1.179-1.179l2.359-2.358a.833.833 0 0 1 1.178 0Zm9.425-8.247a.833.833 0 0 0-1.178-1.178l-2.359 2.358a.833.833 0 0 0 1.179 1.179l2.358-2.359Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.a71f2531ad71b0e03cda7854051a78f3.svg";
export { ForwardRef as ReactComponent };